import Table from 'antd/lib/table';

import styles from './sh-table.module.css';

export default function SHTable({ strategies, columns, loading, handleViewStrategy }) {
    return (
      <div className={styles.tableContainer}>
        <Table
          dataSource={strategies}
          columns={columns}
          rowKey="id"
          loading={loading}
          onRow={(record) => ({
            onClick: () => handleViewStrategy(record),
            className: styles.tableRow
          })}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} strategies`,
            style: { marginTop: 16 }
          }}
        />
      </div>
    )
}